module.exports = "<p>\n  fixed-deduction-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-form/fixed-deduction-form.component.html
// module id = ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-form/fixed-deduction-form.component.html
// module chunks = main